module.exports = __webpack_public_path__ + "assets/img/625745525f5a9bec28308cfc8d88a75a.png";